<template>
    <div class="lp_Breadcrumb" v-if="dataList.length>0">
      <span>您的位置：</span>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="index==dataList.length-1?'':{ path: item.path }" v-for="(item,index) in dataList" :key="index">{{ item.name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
</template>

<script>
  export default {
    name: "lp_Breadcrumb",
    props:{
      breadList:{
        type:Array,
        default:()=>[]
      }
    },
    data () {
      return{
        dataList:[],//面包屑数组
      }
    },
    activated (){
      console.log(this.$route,this.breadList)
      
      const { meta:{breadList} }=this.$route;
        if(breadList){
          this.dataList=breadList;
        }
    },
    methods: {
      
    },
    watch: {
      breadList:{
        handler:function(newVal, oldVal){
          if(this.breadList.length>0){
            this.dataList=this.breadList;
            return;
          };
        },
        deep:true,
        immediate:true
      },
    }
  }
</script>

<style scoped lang="less">
.lp_Breadcrumb{
  padding: 22px 0px;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  &>span{
    margin-right: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/breadcrumb/index.vue